import requests from "./requests";


export default {
  API: {
    Actions: {
      logoff: (csrf) => {
        requests.vue_login();        
        return requests.post(process.env.VUE_APP_BASE_API +
        "/" +
        process.env.VUE_APP_LOGOUT_BACKEND_CAS, {
          _token: csrf,
        });
      },
    },
  },
};